import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import store from "./store";
import "./global-components";
import "./utils";
import "./libs";
import AuthService from './services/Auth';
import VueGtag from "vue-gtag";


Vue.use(VueGtag, {
  config: { id: "G-K840YPGGNB" }
});

// Midone Theme
import "./assets/sass/app.scss";

const API_URL = "https://pmstconverter.com/api/";
// const API_URL = "http://162.214.155.119:8000/api/";
// const API_URL = "http://localhost:8000/api/";

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;
const authService = new AuthService();

Vue.config.productionTip = false;

/**
 * Set base url
 */
axios.interceptors.request.use(config => {
  // console.log(config.url);
  // config.url = API_URL + config.url;
  // Concatenate base path if not an absolute URL
  if (!isAbsoluteURLRegex.test(config.url)) {
    // console.log(config.url);
    config.url = API_URL + config.url;
  }

  return config;
});

/**
 * Set Authorization token to Request
 */
axios.interceptors.request.use(config => {
  if (authService.getToken() !== null && authService.getToken()) {
    config.headers.common["Authorization"] =
      "JWT " + authService.getToken();
  }

  return config;
});

/**
 * Token Refresh
 */
axios.interceptors.response.use(undefined, err => {
  let res = err.response;

  // console.log(res);

  if (
    res.status === 401 &&
    res.data.code === "token_not_valid" &&
    res.data.messages
  ) {
    return new Promise(resolve => {
      let referesh_token = authService.getRefresh();

      axios
        .post("token/refresh/", {
          refresh: referesh_token
        })
        .then(response => {
          if (response.data.code !== "token_not_valid") {
            authService.setToken(response.data.access);
            authService.setRefresh(response.data.refresh);
            err.config.__isRetryRequest = true;
            err.config.headers.Authorization = "JWT " + response.data.access;
            resolve(axios(err.config));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(err => {
          authService.logOut()
          window.location.origin
          // console.log(err);
          // console.log("err");
        });
    });
  }
});

/**
 * Check meta guard
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (authService.getToken() == null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      let user = authService.getUser();
      if (to.matched.some(record => record.meta.is_admin)) {
        if (user.is_superuser === 1) {
          next();
        } else {
          next({ name: "/" });
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (authService.getToken() == null) {
      next();
    } else {
      next({ name: "/" });
    }
  } else {
    next();
  }
});



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
